var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 45 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000244141 5.19231C-0.000244141 2.32468 2.32442 0 5.19206 0H33.6013L44.9998 11.3985V46.7308C44.9998 49.5983 42.675 51.9231 39.8074 51.9231H5.19206C2.32442 51.9231 -0.000244141 49.5983 -0.000244141 46.7308V5.19231ZM8.6536 20.7692H3.46129V38.0769H6.92283V31.1538H8.6536C11.5212 31.1538 13.8459 28.8292 13.8459 25.9615C13.8459 23.0939 11.5212 20.7692 8.6536 20.7692ZM22.4998 20.7692H17.3074V38.0769H22.4998C25.3674 38.0769 27.6921 35.7522 27.6921 32.8846V25.9615C27.6921 23.0939 25.3674 20.7692 22.4998 20.7692ZM31.1536 38.0769V20.7692H41.5382V24.2308H34.6151V27.6923H38.0767V31.1538H34.6151V38.0769H31.1536Z",
    fill: "#4BC7E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.cf93ba2cbe9c2cfaf993777578927f4c.svg";
export { ForwardRef as ReactComponent };